// @ts-nocheck
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { isDesktop } from 'react-device-detect';
import { AppTopbar } from './AppTopbar';
import { AppMenu } from './AppMenu';
import { AppConfig } from './AppConfig';
import { AppStatusBar } from './AppStatusBar';
import { BaseLayerList } from '../functionalComponents/BaseLayerList';
import { TerrainLayerList } from '../functionalComponents/TerrainLayerList';
import { Layer2DList } from '../functionalComponents/Layer2DList';
import { Layer3DList } from '../functionalComponents/Layer3DList';
import { GoogleSearchComponents } from '../functionalComponents/GoogleSearchComponents';
import { SurveyingComponents } from '../functionalComponents/SurveyingComponents';
import { AnalysisComponents } from '../functionalComponents/AnalysisComponents';
import { MarkComponents } from '../functionalComponents/MarkComponents';
import { ParticleEffectComponents } from '../functionalComponents/ParticleEffectComponents';
import { EnviromentEffectComponents } from '../functionalComponents/EnviromentEffectComponents';
import { WeatherModuleComponents } from '../functionalComponents/WeatherModuleComponents';
import { FluidComponents } from '../functionalComponents/FluidComponents';
import { GPXTrajectoryComponents } from '../functionalComponents/GPXTrajectoryComponents';
import { ProjectorComponents } from '../functionalComponents/ProjectorComponents';
import { ModelWalkComponents } from '../functionalComponents/ModelWalkComponents';
import { TerrainDrawSettingComponents } from '../functionalComponents/TerrainDrawSettingComponents';
import { LightSettingComponents } from '../functionalComponents/LightSettingComponents';
import { TimeLineSettingComponents } from '../functionalComponents/TimeLineSettingComponents';
import { SatelliteModuleComponents } from '../functionalComponents/SatelliteModuleComponents';
import PrimeReact from 'primereact/api';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'prismjs/themes/prism-coy.css';
import '../assets/layout/layout.scss';
import './MenuSide.css'

export const MenuSide = () => {
    const [layoutColorMode, setLayoutColorMode] = useState('dark');
    const [staticMenuInactive, setStaticMenuInactive] = useState(false);
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [mobileTopbarMenuActive, setMobileTopbarMenuActive] = useState(false);
    const [TerrainList, setTerrainList] = useState(false);
    const [BaseLayer, setBaseLayer] = useState(false);
    const [Layer2D, setLayer2D] = useState(false);
    const [Layer3D, setLayer3D] = useState(false);
    const [GoogleSearch, setGoogleSearch] = useState(false);
    const [Surveying, setSurveying] = useState(false);
    const [Analysis, setAnalysis] = useState(false);
    const [Mark, setMark] = useState(false);
    const [Particle, setParticle] = useState(false);
    const [Enviroment, setEnviroment] = useState(false);
    const [Weather, setWeather] = useState(false);
    const [Fluid, setFluid] = useState(false);
    const [Trajectory, setTrajectory] = useState(false);
    const [Projector, setProjector] = useState(false);
    const [ModelWalk, setModelWalk] = useState(false);
    const [TerrainDrawSetting, setTerrainDrawSetting] = useState(false);
    const [LightSetting, setLightSetting] = useState(false);
    const [TimeLineSetting, setTimeLineSetting] = useState(false);
    const [SatelliteModule, setSatelliteModule] = useState(false);
    const [DTMAnalysisAPI, setDTMAnalysisAPI] = useState(false);
    const [selected2Dlayer, setSelected2Dlayer] = useState([]);

    const ripple = true;
    const inputStyle = 'outlined';
    const layoutMode = 'static';

    const dialogFuncMap = {
        'TerrainList': setTerrainList,
        'BaseLayer': setBaseLayer,
        'Layer2D': setLayer2D,
        'Layer3D': setLayer3D,
        'GoogleSearch': setGoogleSearch,
        'Surveying': setSurveying,
        'Analysis': setAnalysis,
        'Mark': setMark,
        'Particle': setParticle,
        'Enviroment': setEnviroment,
        'Weather': setWeather,
        'Fluid': setFluid,
        'Trajectory': setTrajectory,
        'Projector': setProjector,
        'ModelWalk': setModelWalk,
        'TerrainDrawSetting': setTerrainDrawSetting,
        'LightSetting': setLightSetting,
        'TimeLineSetting': setTimeLineSetting,
        'SatelliteModule': setSatelliteModule,
        'DTMAnalysisAPI': setDTMAnalysisAPI,
    }

    PrimeReact.ripple = true;

    let menuClick = false;
    let mobileTopbarMenuClick = false;

    useEffect(() => {
        if (mobileMenuActive) {
            addClass(document.body, "body-overflow-hidden");
        } else {
            removeClass(document.body, "body-overflow-hidden");
        }
    }, [mobileMenuActive]);

    const onColorModeChange = (mode: React.SetStateAction<string>) => {
        setLayoutColorMode(mode)
    }

    const onMenuItemClick = (name) => {
        switch (name) {
            case "CIoTSensorThingsModule":
                new ov.Widget.SensorThings({ view: window.main.OView });
                break;
            case "DTMAnalysisAPI":
                new ov.Widget.DTM({ view: window.main.OView, proxy: "dtm.ashx?" });
                break;
            default: 
                dialogFuncMap[`${name}`](true);
                break;
        }
    }

    const onHide = (name) => {
        dialogFuncMap[`${name}`](false);
    }

    const onWrapperClick = (event: any) => {
        if (!menuClick) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }

        if (!mobileTopbarMenuClick) {
            setMobileTopbarMenuActive(false);
        }

        mobileTopbarMenuClick = false;
        menuClick = false;
    }

    const onToggleMenuClick = (event: { preventDefault: () => void; }) => {
        menuClick = true;

        if (isDesktopCheck()) {
            if (layoutMode === 'overlay') {
                if (mobileMenuActive === true) {
                    setOverlayMenuActive(true);
                }

                setOverlayMenuActive((prevState) => !prevState);
                setMobileMenuActive(false);
            }
            else if (layoutMode === 'static') {
                setStaticMenuInactive((prevState) => !prevState);
            }
        }
        else {
            setMobileMenuActive((prevState) => !prevState);
        }

        event.preventDefault();
    }

    const onSidebarClick = () => {
        menuClick = true;
    }

    const onMobileTopbarMenuClick = (event: { preventDefault: () => void; }) => {
        mobileTopbarMenuClick = true;

        setMobileTopbarMenuActive((prevState) => !prevState);
        event.preventDefault();
    }

    const onMobileSubTopbarMenuClick = (event: { preventDefault: () => void; }) => {
        mobileTopbarMenuClick = true;

        event.preventDefault();
    }

    const isDesktopCheck = () => {
        return window.innerWidth >= 992;
    }
    // icon使用：https://ionic.io/ionicons
    const menu = [
        {
            label: '圖層集',
            items: [
                { label: '地形列表', name: 'TerrainList', icon: 'earth' },
                { label: '底圖列表', name: 'BaseLayer', icon: 'map' },
                { label: '2D圖層', name: 'Layer2D', icon: 'image' },
                { label: '3D圖層', name: 'Layer3D', icon: 'business' },
            ]
        },
        {
            label: '功能集',
            items: [
                { label: '搜尋', name: 'GoogleSearch', icon: 'search' },
                { label: '測量', name: 'Surveying', icon: 'crop' },
                { label: '分析', name: 'Analysis', icon: 'bar-chart' },
                { label: '標註', name: 'Mark', icon: 'flag' },
            ]
        },
        {
            label: '全域設定',
            items: [
                { label: '地形地表設定', name: 'TerrainDrawSetting', icon: 'settings' },
                { label: '日光設定', name: 'LightSetting', icon: 'sunny' },
                { label: '時間軸設定', name: 'TimeLineSetting', icon: 'time'}
            ]
        },
        {
            label: '特殊應用模組',
            items: [
                { label: '衛星模組', name: 'SatelliteModule', icon: 'planet' },
                { label: '虛實整合攝影機', name: 'Projector', icon: 'aperture'},
                { label: '模型行走模擬', name: 'ModelWalk', icon: 'walk'},
                { label: '民生公共物聯網', name: 'CIoTSensorThingsModule', icon: 'wifi' },
                { label: '地政司API', name: 'DTMAnalysisAPI', icon: 'pulse' },
            ]
        },
        {
            label: '場域環境功能模組',
            items: [
                { label: '粒子特效', name: 'Particle', icon: 'apps'},
                { label: '環境特效', name: 'Enviroment', icon: 'globe'},
                { label: '氣象模組', name: 'Weather', icon: 'thunderstorm'},
                { label: '流體分析', name: 'Fluid', icon: 'stats-chart'},
                { label: 'GPX軌跡模組', name: 'Trajectory', icon:'paper-plane'},
            ]
        }
    ];

    const addClass = (element: HTMLElement, className: string) => {
        if (element.classList)
            element.classList.add(className);
        else
            element.className += ' ' + className;
    }

    const removeClass = (element: HTMLElement, className: string) => {
        if (element.classList)
            element.classList.remove(className);
        else
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    const wrapperClass = classNames('layout-wrapper', {
        'layout-overlay': layoutMode === 'overlay',
        'layout-static': layoutMode === 'static',
        'layout-static-sidebar-inactive': staticMenuInactive && layoutMode === 'static',
        'layout-overlay-sidebar-active': overlayMenuActive && layoutMode === 'overlay',
        'layout-mobile-sidebar-active': mobileMenuActive,
        'p-input-filled': inputStyle === 'filled',
        'p-ripple-disabled': ripple === false,
        'layout-theme-light': layoutColorMode === 'light'
    });
    return (
        <div className={wrapperClass} onClick={onWrapperClick}>
            <AppTopbar onToggleMenuClick={onToggleMenuClick} layoutColorMode={layoutColorMode}
                mobileTopbarMenuActive={mobileTopbarMenuActive} onMobileTopbarMenuClick={onMobileTopbarMenuClick} onMobileSubTopbarMenuClick={onMobileSubTopbarMenuClick} />

            <div className="layout-sidebar" onClick={onSidebarClick}>
                <AppMenu model={menu} onMenuItemClick={onMenuItemClick} layoutColorMode={layoutColorMode} />
            </div>

            <div className="layout-main-container">
                <TerrainLayerList TerrainList={TerrainList} onHide={onHide} />
                <BaseLayerList BaseLayer={BaseLayer} onHide={onHide} />
                <Layer2DList Layer2D={Layer2D} onHide={onHide} setSelected2Dlayer={setSelected2Dlayer} />
                <Layer3DList Layer3D={Layer3D} onHide={onHide} selected2Dlayer={selected2Dlayer} />
                <GoogleSearchComponents GoogleSearch={GoogleSearch} onHide={onHide} />
                <SurveyingComponents Surveying={Surveying} onHide={onHide} />
                <AnalysisComponents Analysis={Analysis} onHide={onHide} />
                <MarkComponents Mark={Mark} onHide={onHide} />
                <ParticleEffectComponents Particle={Particle} onHide={onHide} />
                <EnviromentEffectComponents Enviroment={Enviroment} onHide={onHide} />
                <WeatherModuleComponents Weather={Weather} onHide={onHide} />
                <FluidComponents Fluid={Fluid} onHide={onHide} />
                <GPXTrajectoryComponents Trajectory={Trajectory} onHide={onHide} />
                <ProjectorComponents Projector={Projector} onHide={onHide} />
                <ModelWalkComponents ModelWalk={ModelWalk} onHide={onHide} />
                <TerrainDrawSettingComponents TerrainDrawSetting={TerrainDrawSetting} onHide={onHide} />
                <LightSettingComponents LightSetting={LightSetting} onHide={onHide}/>
                <TimeLineSettingComponents TimeLineSetting={TimeLineSetting} onHide={onHide}/>
                <SatelliteModuleComponents SatelliteModule={SatelliteModule} onHide={onHide} />
            </div>

            <AppConfig rippleEffect={ripple} inputStyle={inputStyle} layoutMode={layoutMode} layoutColorMode={layoutColorMode} onColorModeChange={onColorModeChange} />
            
            {
                isDesktop ?
                    <AppStatusBar /> : null
            }
        </div>
    );
}